<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="modalController.dismiss()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Signature</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content forceOverscroll="false">
<!--   [hidden]="!screenLoaded" -->
    <canvas class="signature-pad-canvas" [hidden]="!screenLoaded" #imageCanvas width="900" height="400"></canvas>
<!--    <canvas #imageCanvas [hidden]="!screenLoaded" (touchstart)="startDrawing($event)" (touchmove)="moved($event)"-->
<!--            style='border: 1px solid black;'></canvas>-->
    <ion-fab vertical="bottom" horizontal="end">
        <ion-fab-button (click)="saveCanvas()" color="success">
            <ion-icon name="checkmark"></ion-icon>
        </ion-fab-button>
    </ion-fab>
    <ion-fab vertical="bottom" horizontal="start">
        <ion-fab-button (click)="clearCanvas()" color="danger">
            <ion-icon name="close"></ion-icon>
        </ion-fab-button>
    </ion-fab>
</ion-content>
